module.exports = __webpack_public_path__ + "img/lunar-base.a582c576.jpg";